import React from "react"
import { graphql, useStaticQuery } from "gatsby"

const query = graphql`
  {
    strapiCompanyInformation {
      phone_india
    }
  }
`

const toWhatsAppNumber = value => {
  const cleaned = (value || "").replace(/\D+/g, "")
  if (!cleaned) return "919898582705"
  if (cleaned.startsWith("0")) return `91${cleaned.replace(/^0+/, "")}`
  if (cleaned.length <= 10) return `91${cleaned}`
  return cleaned
}

const StickyWhatsAppButton = () => {
  const data = useStaticQuery(query)
  const phoneIndia = data?.strapiCompanyInformation?.phone_india
  const whatsappNumber = toWhatsAppNumber(phoneIndia)
  const message = "SrashtaSoft | Innovative IT Solutions"
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    message
  )}`

  return (
    <a
      className="sticky-whatsapp-btn"
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp"
    >
      <i className="bx bxl-whatsapp" aria-hidden="true"></i>
    </a>
  )
}

export default StickyWhatsAppButton
